import { render, staticRenderFns } from "./UsersDetails.vue?vue&type=template&id=470c4d05&scoped=true"
import script from "./UsersDetails.vue?vue&type=script&lang=js"
export * from "./UsersDetails.vue?vue&type=script&lang=js"
import style0 from "./UsersDetails.vue?vue&type=style&index=0&id=470c4d05&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470c4d05",
  null
  
)

export default component.exports